import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IRequestResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "environments/environment.prod";
import { Observable } from "rxjs";
import { TripAttributes } from "@albatrosdeveloper/ave-models-package";
import { ExtendsTrips, FilterVisitPayload } from "app/shared/components/map-modal/models/map-modal.interface";
import { PrincipalScreenService } from "app/modules/components/monitor/principal-screen/principal-screen.service";
import { andAllWhere, buildQuery, FilterFn, Ops, seed } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";

const apiUrl = env.API_AVE_TRIP_URL;
const moduleName = "trip";

@Injectable({
  providedIn: "root",
})
export class MapModalTripService extends AbstractService<
  TripAttributes,
  Partial<TripAttributes>,
  Partial<TripAttributes>
> {

  constructor(
    http: HttpClient,
    private readonly principalScreenService: PrincipalScreenService
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
    * 
    * Servicio para traer todos los viajes en monitor
    * @returns Paginated data
    */
  findAllRouteTripFilter(filter?: FilterVisitPayload, isFilterPage: boolean = false): Observable<IRequestResult<ExtendsTrips[]>> {
    const filters: FilterFn<TripAttributes>[] = [];
    const baseFilter = isFilterPage
    ? this.principalScreenService.currentFilter
    : (() => {
        const clean = { ...this.principalScreenService.currentFilter };
        delete clean.page;
        return clean;
      })();

    filters.push(seed(baseFilter));

    if(filter.subRouteId && filter.subRouteId.length > 0){
      filters.push(andAllWhere("subRoute.id" as keyof TripAttributes,Ops.in(...filter.subRouteId)))
    }

    if(filter.subRouteType != null){
      filters.push(andAllWhere("subRoute.type" as keyof TripAttributes,Ops.eq(filter.subRouteType)))
    }

    if(filter.statusTripId != null){
      filters.push(andAllWhere("statusTripId", Ops.eq(filter.statusTripId)))
    }

    const query = buildQuery<TripAttributes>(...filters);

    const API_URL: string = apiUrl + `api/${moduleName}/map`;
    return this.http.post<IRequestResult<ExtendsTrips[]>>(API_URL, {
      filter: query,
      name: filter.reasonVisit ?? null
    });
  }
}